import { useQuery } from '@tanstack/react-query';
import { getSuchenPlusStatus } from '@/api/suchenPlus/getSuchenPlusStatus';

export const useGetSuchenPlusStatus = () => {
  const { data } = useQuery({
    queryKey: ['suchen-plus-status'],
    queryFn: getSuchenPlusStatus,
  });

  return {
    suchenPlusStatus: data,
  };
};
